import { render, staticRenderFns } from "./StartupsByDateAndTrackerChart.vue?vue&type=template&id=4cff132e&"
import script from "./StartupsByDateAndTrackerChart.vue?vue&type=script&lang=js&"
export * from "./StartupsByDateAndTrackerChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports